import { SET_SNACKBAR_STATE } from '@/constants';
var snackbarTimer = null;
export var hideSnack = function () {
    if (snackbarTimer) {
        clearTimeout(snackbarTimer);
    }
    return { type: SET_SNACKBAR_STATE, payload: false };
};
export var showSnack = function (payload) { return function (dispatch) {
    dispatch({ type: SET_SNACKBAR_STATE, payload: payload });
    if (snackbarTimer) {
        clearTimeout(snackbarTimer);
    }
    snackbarTimer = setTimeout(function () {
        dispatch(hideSnack());
    }, 3000);
}; };
